import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { PaymentMethod } from '@vestiaire/api-sdk-angular';
import { LocaleService } from '@app/core/i18n';
import { IAppState } from '@app/store';
import { Store } from '@ngrx/store';
import { take } from 'rxjs/operators';

@Component({
  selector: 'vc-footer-payment-mode',
  templateUrl: './footer-payment-mode.component.html',
  styleUrls: ['./footer-payment-mode.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FooterPaymentModeComponent implements OnInit {
  public payments: Array<PaymentMethod>;
  public isGermany = false;
  public currentCountry: string;

  constructor(private localeService: LocaleService, private store: Store<IAppState>) {}

  ngOnInit() {
    this.currentCountry = this.localeService.getCountry();
    if (this.currentCountry === 'DE') {
      this.isGermany = true;
    }

    this.store
      .select('paymentMethods')
      .pipe(take(2))
      .subscribe(
        res => {
          if (res) {
            this.payments = res.paymentMethods;
          }
        },
        err => {
          // Silently catch exception
        }
      );
  }
}
